import React, { useState } from 'react';

const ContactSection = ({ onOpenConsultation }) => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    service: '',
    budget: '',
    message: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <section
      id="contact"
      style={{
        padding: '60px 0 70px 0',
        position: 'relative',
        zIndex: 2,
        background: '#040612',
        color: '#FFFFFF',
        fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      {/* Background Ambient Radial Glows */}
      <div
        style={{
          position: 'absolute',
          top: '20%',
          left: '10%',
          width: '450px',
          height: '450px',
          background: 'radial-gradient(circle, rgba(99, 102, 241, 0.1) 0%, rgba(0,0,0,0) 70%)',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '10%',
          right: '10%',
          width: '450px',
          height: '450px',
          background: 'radial-gradient(circle, rgba(56, 189, 248, 0.1) 0%, rgba(0,0,0,0) 70%)',
          pointerEvents: 'none',
        }}
      />

      <div className="ht-container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        
        {/* ======================================================== */}
        {/* TOP CTA BANNER CONTAINER */}
        {/* ======================================================== */}
        <div
          style={{
            background: 'linear-gradient(145deg, rgba(13, 17, 38, 0.9) 0%, rgba(8, 11, 24, 0.95) 100%)',
            borderRadius: '24px',
            border: '1px solid rgba(139, 92, 246, 0.3)',
            padding: '40px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5), 0 0 30px rgba(139, 92, 246, 0.15)',
            marginBottom: '26px',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {/* Subtle Top Glow Line */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '2px',
              background: 'linear-gradient(90deg, transparent 0%, #A855F7 50%, transparent 100%)',
            }}
          />

          <div
            className="cta-banner-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: '1.2fr 1fr',
              gap: '30px',
              alignItems: 'center',
            }}
          >
            {/* Left Content */}
            <div>
              {/* Tag Pill */}
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '5px 14px',
                  borderRadius: '20px',
                  background: 'rgba(56, 189, 248, 0.1)',
                  border: '1px solid rgba(56, 189, 248, 0.3)',
                  fontSize: '0.68rem',
                  fontWeight: 800,
                  letterSpacing: '1px',
                  color: '#38BDF8',
                  marginBottom: '16px',
                }}
              >
                <span style={{ fontSize: '0.6rem' }}>✦</span>
                <span>READY TO INNOVATE?</span>
              </div>

              {/* Title */}
              <h2
                style={{
                  fontSize: 'clamp(2rem, 3.8vw, 2.9rem)',
                  fontWeight: 800,
                  letterSpacing: '-0.03em',
                  margin: '0 0 14px 0',
                  lineHeight: 1.15,
                  color: '#FFFFFF',
                }}
              >
                Let's Build Something <br />
                <span
                  style={{
                    background: 'linear-gradient(90deg, #A855F7 0%, #38BDF8 60%, #00D4FF 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  Incredible
                </span>{' '}
                Together
              </h2>

              {/* Description */}
              <p
                style={{
                  color: '#94A3B8',
                  fontSize: '0.92rem',
                  lineHeight: 1.55,
                  maxWidth: '520px',
                  margin: '0 0 24px 0',
                }}
              >
                Whether you need a custom AI platform, digital lending engine, or enterprise cloud software, our team is ready to deliver innovative solutions that drive real results.
              </p>

              {/* Action Buttons */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap', marginBottom: '28px' }}>
                <button
                  onClick={onOpenConsultation}
                  style={{
                    background: 'linear-gradient(90deg, #6366F1 0%, #3B82F6 100%)',
                    boxShadow: '0 4px 20px rgba(99, 102, 241, 0.4)',
                    border: 'none',
                    borderRadius: '30px',
                    color: '#FFFFFF',
                    padding: '11px 24px',
                    fontSize: '0.85rem',
                    fontWeight: 700,
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                  <span>Schedule a Meeting</span>
                </button>

                <a
                  href="mailto:contact@hungrytoptech.com"
                  style={{
                    background: 'rgba(255, 255, 255, 0.04)',
                    border: '1px solid rgba(255, 255, 255, 0.18)',
                    borderRadius: '30px',
                    color: '#FFFFFF',
                    padding: '11px 24px',
                    fontSize: '0.85rem',
                    fontWeight: 700,
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    transition: 'background 0.2s',
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#A855F7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  <span>Email Engineering Team</span>
                </a>
              </div>

              {/* 4 Feature Badges */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  gap: '10px',
                }}
                className="banner-features-grid"
              >
                {/* 1. Security */}
                <div
                  style={{
                    background: 'rgba(255, 255, 255, 0.03)',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    borderRadius: '12px',
                    padding: '8px 10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#38BDF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  </svg>
                  <div>
                    <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#FFFFFF', lineHeight: 1.1 }}>Enterprise</div>
                    <div style={{ fontSize: '0.62rem', color: '#94A3B8' }}>Grade Security</div>
                  </div>
                </div>

                {/* 2. Response Time */}
                <div
                  style={{
                    background: 'rgba(255, 255, 255, 0.03)',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    borderRadius: '12px',
                    padding: '8px 10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                  <div>
                    <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#FFFFFF', lineHeight: 1.1 }}>Fast</div>
                    <div style={{ fontSize: '0.62rem', color: '#94A3B8' }}>Response Time</div>
                  </div>
                </div>

                {/* 3. Expert Team */}
                <div
                  style={{
                    background: 'rgba(255, 255, 255, 0.03)',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    borderRadius: '12px',
                    padding: '8px 10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#A855F7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                  <div>
                    <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#FFFFFF', lineHeight: 1.1 }}>Expert</div>
                    <div style={{ fontSize: '0.62rem', color: '#94A3B8' }}>Engineering Team</div>
                  </div>
                </div>

                {/* 4. Tailored Solutions */}
                <div
                  style={{
                    background: 'rgba(255, 255, 255, 0.03)',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    borderRadius: '12px',
                    padding: '8px 10px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#34D399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <div>
                    <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#FFFFFF', lineHeight: 1.1 }}>Tailored</div>
                    <div style={{ fontSize: '0.62rem', color: '#94A3B8' }}>Solutions</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side High-Tech 3D Platform Illustration */}
            <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
              <svg width="340" height="260" viewBox="0 0 340 260" fill="none">
                <g opacity="0.95">
                  {/* Glowing Bottom Base Platform Ring */}
                  <ellipse cx="170" cy="210" rx="140" ry="40" fill="rgba(99, 102, 241, 0.15)" stroke="rgba(99, 102, 241, 0.3)" strokeWidth="1.5" />
                  
                  {/* Stacked 3D Isometric Platform Layer 1 */}
                  <path d="M170 140 L280 180 L170 220 L60 180 Z" fill="rgba(15, 23, 42, 0.95)" stroke="#6366F1" strokeWidth="1.8" />
                  <path d="M60 180 L170 220 L170 228 L60 188 Z" fill="#4338CA" />
                  <path d="M170 220 L280 180 L280 188 L170 228 Z" fill="#3730A3" />

                  {/* Stacked 3D Isometric Platform Layer 2 */}
                  <path d="M170 120 L250 152 L170 184 L90 152 Z" fill="rgba(30, 27, 75, 0.9)" stroke="#818CF8" strokeWidth="1.8" />
                  
                  {/* Central Glowing 3D Glass Cube */}
                  <path d="M170 85 L200 100 L170 115 L140 100 Z" fill="#C084FC" />
                  <path d="M140 100 L170 115 L170 138 L140 123 Z" fill="#9333EA" />
                  <path d="M170 115 L200 100 L200 123 L170 138 Z" fill="#A855F7" />

                  {/* Floating Screen 1: Team & Users UI */}
                  <g transform="translate(45, 45)">
                    <rect x="0" y="0" width="75" height="52" rx="6" fill="rgba(15, 23, 42, 0.92)" stroke="#38BDF8" strokeWidth="1.5" />
                    <circle cx="28" cy="22" r="6" fill="#38BDF8" />
                    <circle cx="46" cy="22" r="6" fill="#818CF8" />
                    <rect x="15" y="36" width="44" height="4" rx="2" fill="#BAE6FD" />
                  </g>

                  {/* Floating Screen 2: Main Code & Cloud Architecture UI */}
                  <g transform="translate(195, 20)">
                    <rect x="0" y="0" width="95" height="70" rx="8" fill="rgba(15, 23, 42, 0.95)" stroke="#38BDF8" strokeWidth="1.8" />
                    <line x1="12" y1="18" x2="45" y2="18" stroke="#38BDF8" strokeWidth="2.5" strokeLinecap="round" />
                    <line x1="12" y1="28" x2="75" y2="28" stroke="#C084FC" strokeWidth="2" strokeLinecap="round" />
                    <line x1="22" y1="38" x2="60" y2="38" stroke="#818CF8" strokeWidth="2" strokeLinecap="round" />
                    <line x1="22" y1="48" x2="80" y2="48" stroke="#34D399" strokeWidth="2" strokeLinecap="round" />
                  </g>

                  {/* Floating Screen 3: Telemetry Bar Chart UI */}
                  <g transform="translate(240, 110)">
                    <rect x="0" y="0" width="65" height="50" rx="6" fill="rgba(15, 23, 42, 0.92)" stroke="#C084FC" strokeWidth="1.5" />
                    <rect x="12" y="26" width="6" height="14" rx="1" fill="#A855F7" />
                    <rect x="22" y="20" width="6" height="20" rx="1" fill="#C084FC" />
                    <rect x="32" y="14" width="6" height="26" rx="1" fill="#E9D5FF" />
                    <rect x="42" y="10" width="6" height="30" rx="1" fill="#38BDF8" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>

        {/* ======================================================== */}
        {/* BOTTOM DIRECT INQUIRY FORM CONTAINER */}
        {/* ======================================================== */}
        <div
          style={{
            background: 'linear-gradient(145deg, rgba(11, 15, 33, 0.9) 0%, rgba(6, 9, 20, 0.95) 100%)',
            borderRadius: '24px',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            padding: '36px 40px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
          }}
        >
          {/* Header Row */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '28px', flexWrap: 'wrap', gap: '16px' }}>
            <div>
              <h3 style={{ fontSize: '1.6rem', color: '#FFFFFF', fontWeight: 800, margin: '0 0 6px 0', letterSpacing: '-0.02em' }}>
                Request Enterprise Project Quote
              </h3>
              <p style={{ color: '#94A3B8', margin: 0, fontSize: '0.88rem' }}>
                Fill out the details below and an enterprise software architect will respond within 4 hours.
              </p>
            </div>

            {/* Avg Response Time Pill */}
            <div
              style={{
                background: 'rgba(52, 211, 153, 0.08)',
                border: '1px solid rgba(52, 211, 153, 0.3)',
                borderRadius: '12px',
                padding: '8px 14px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <div
                style={{
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  background: 'rgba(52, 211, 153, 0.18)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#34D399',
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </div>
              <div>
                <div style={{ fontSize: '0.62rem', color: '#94A3B8', fontWeight: 600 }}>Avg. Response Time</div>
                <div style={{ fontSize: '0.78rem', color: '#34D399', fontWeight: 800 }}>Under 4 Hours</div>
              </div>
            </div>
          </div>

          {submitted ? (
            <div
              style={{
                textAlign: 'center',
                padding: '40px 20px',
                background: 'rgba(52, 211, 153, 0.1)',
                borderRadius: '16px',
                border: '1px solid rgba(52, 211, 153, 0.3)',
              }}
            >
              <div
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: 'rgba(52, 211, 153, 0.2)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#34D399',
                  marginBottom: '14px',
                }}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <h4 style={{ fontSize: '1.4rem', color: '#FFF', margin: '0 0 8px 0', fontWeight: 800 }}>Request Received!</h4>
              <p style={{ color: '#94A3B8', fontSize: '0.92rem', margin: 0 }}>
                Thank you {formData.name}. Our enterprise team has received your project details and will reach out to <strong>{formData.email}</strong> shortly.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: '18px' }}>
              {/* Name */}
              <div style={{ gridColumn: 'span 6' }} className="form-col">
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', color: '#CBD5E1', marginBottom: '8px', fontWeight: 700 }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  Your Full Name *
                </label>
                <input
                  type="text"
                  required
                  placeholder="e.g. David Vance"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    borderRadius: '12px',
                    background: 'rgba(255, 255, 255, 0.03)',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    color: '#FFFFFF',
                    fontSize: '0.88rem',
                    outline: 'none',
                    boxSizing: 'border-box',
                  }}
                />
              </div>

              {/* Email */}
              <div style={{ gridColumn: 'span 6' }} className="form-col">
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', color: '#CBD5E1', marginBottom: '8px', fontWeight: 700 }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  Work Email Address *
                </label>
                <input
                  type="email"
                  required
                  placeholder="david@company.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    borderRadius: '12px',
                    background: 'rgba(255, 255, 255, 0.03)',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    color: '#FFFFFF',
                    fontSize: '0.88rem',
                    outline: 'none',
                    boxSizing: 'border-box',
                  }}
                />
              </div>

              {/* Solution */}
              <div style={{ gridColumn: 'span 6' }} className="form-col">
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', color: '#CBD5E1', marginBottom: '8px', fontWeight: 700 }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="4" y1="21" x2="4" y2="14"></line>
                    <line x1="4" y1="10" x2="4" y2="3"></line>
                    <line x1="12" y1="21" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12" y2="3"></line>
                    <line x1="20" y1="21" x2="20" y2="16"></line>
                    <line x1="20" y1="12" x2="20" y2="3"></line>
                  </svg>
                  Project Solution Needed
                </label>
                <select
                  value={formData.service}
                  onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    borderRadius: '12px',
                    background: '#0B0F24',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    color: formData.service ? '#FFFFFF' : '#94A3B8',
                    fontSize: '0.88rem',
                    outline: 'none',
                    boxSizing: 'border-box',
                    cursor: 'pointer',
                  }}
                >
                  <option value="" disabled style={{ color: '#94A3B8' }}>Select a solution</option>
                  <option value="AI & Custom Software" style={{ background: '#0F172A', color: '#FFF' }}>AI & Custom Software Platform</option>
                  <option value="PaperLoan Digital Lending" style={{ background: '#0F172A', color: '#FFF' }}>PaperLoan Digital Lending Engine</option>
                  <option value="HungryTop Restaurant Platform" style={{ background: '#0F172A', color: '#FFF' }}>HungryTop Commerce SaaS</option>
                  <option value="SocialSphere AI Suite" style={{ background: '#0F172A', color: '#FFF' }}>SocialSphere AI Automation Suite</option>
                  <option value="ApexAnalytics AI Platform" style={{ background: '#0F172A', color: '#FFF' }}>ApexAnalytics AI Intelligence</option>
                  <option value="Cloud & DevOps Infrastructure" style={{ background: '#0F172A', color: '#FFF' }}>Cloud & DevOps Infrastructure</option>
                </select>
              </div>

              {/* Budget */}
              <div style={{ gridColumn: 'span 6' }} className="form-col">
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', color: '#CBD5E1', marginBottom: '8px', fontWeight: 700 }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="1" x2="12" y2="23"></line>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                  </svg>
                  Estimated Budget
                </label>
                <select
                  value={formData.budget}
                  onChange={(e) => setFormData({ ...formData, budget: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    borderRadius: '12px',
                    background: '#0B0F24',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    color: formData.budget ? '#FFFFFF' : '#94A3B8',
                    fontSize: '0.88rem',
                    outline: 'none',
                    boxSizing: 'border-box',
                    cursor: 'pointer',
                  }}
                >
                  <option value="" disabled style={{ color: '#94A3B8' }}>Select your budget range</option>
                  <option value="$10k - $25k" style={{ background: '#0F172A', color: '#FFF' }}>$10,000 - $25,000</option>
                  <option value="$25k - $50k" style={{ background: '#0F172A', color: '#FFF' }}>$25,000 - $50,000</option>
                  <option value="$50k - $100k" style={{ background: '#0F172A', color: '#FFF' }}>$50,000 - $100,000</option>
                  <option value="$100k+" style={{ background: '#0F172A', color: '#FFF' }}>$100,000+</option>
                </select>
              </div>

              {/* Textarea Overview */}
              <div style={{ gridColumn: 'span 12' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', color: '#CBD5E1', marginBottom: '8px', fontWeight: 700 }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#818CF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                  </svg>
                  Project Overview & Scope
                </label>
                <div style={{ position: 'relative' }}>
                  <textarea
                    rows="4"
                    required
                    maxLength="1000"
                    placeholder="Describe your project goals, timelines, key requirements, and any specific challenges..."
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      borderRadius: '12px',
                      background: 'rgba(255, 255, 255, 0.03)',
                      border: '1px solid rgba(255, 255, 255, 0.12)',
                      color: '#FFFFFF',
                      fontSize: '0.88rem',
                      outline: 'none',
                      resize: 'vertical',
                      boxSizing: 'border-box',
                    }}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '10px',
                      right: '14px',
                      fontSize: '0.66rem',
                      color: '#64748B',
                      pointerEvents: 'none',
                    }}
                  >
                    {formData.message.length}/1000
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div style={{ gridColumn: 'span 12', marginTop: '6px' }}>
                <button
                  type="submit"
                  style={{
                    width: '100%',
                    padding: '14px',
                    borderRadius: '30px',
                    background: 'linear-gradient(90deg, #6366F1 0%, #3B82F6 100%)',
                    boxShadow: '0 4px 22px rgba(99, 102, 241, 0.4)',
                    border: 'none',
                    color: '#FFFFFF',
                    fontSize: '0.92rem',
                    fontWeight: 700,
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                  }}
                >
                  <span>Submit Project Inquiry</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                </button>
              </div>

              {/* Secure Subtext */}
              <div style={{ gridColumn: 'span 12', textAlign: 'center', marginTop: '4px' }}>
                <span style={{ fontSize: '0.72rem', color: '#64748B', display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </svg>
                  Your information is secure and will never be shared.
                </span>
              </div>
            </form>
          )}
        </div>

      </div>

      {/* Embedded CSS for responsive layout */}
      <style>{`
        @media (max-width: 1024px) {
          .cta-banner-grid {
            grid-template-columns: 1fr !important;
          }
          .banner-features-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 640px) {
          .form-col {
            grid-column: span 12 !important;
          }
          .banner-features-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ContactSection;
